// Generated by scripts/generate-funnel.mjs from products/mellow-puff-pillow.config.json
// Do not edit this file directly; update the product config and rerun npm run generate.
import type { FunnelConfig } from "../lib/types";

export const funnel = {
  "brand": "Mellow Sleep",
  "product": {
    "name": "Mellow Sleep Mellow Puff Pillow",
    "shortName": "Mellow Puff Pillow",
    "sourceUrl": "https://www.tiktok.com/shop/pdp/mens-athletic-t-shirt-by-brand-lightweight-quick-dry-crew-neck-tops/1729494528714773585?source=ecommerce_store&region=US",
    "liveSourceStatus": "Fetched successfully with a Googlebot user agent on 2026-06-16. The URL slug is misleading; the product ID resolves to Mellow Sleep Mellow Puff Pillow, not a men's T-shirt.",
    "category": "Textiles & Soft Furnishings > Bedding and Linens > Pillows & Bed Wedges > Standard Pillows",
    "description": "A soft quilted puff-grid bed pillow wrapped in cooling ice-silk fabric, built for cloud-like plush comfort across side, back, and stomach sleepers. TikTok Shop app state describes it as machine washable and designed to stay plush night after night.",
    "features": [
      "Quilted puff-grid design",
      "Cooling ice-silk fabric",
      "Soft, fluffy, cloud-like feel",
      "For side, back, and stomach sleepers",
      "Machine washable",
      "Regular and King sizes",
      "White, Baby Blue, Gray, Baby Pink, and Lavender colorways"
    ],
    "assumptions": [
      "The TikTok URL slug is treated as unreliable; product facts come from parsed JSON-LD and __MODERN_ROUTER_DATA__ in the fetched HTML.",
      "Generated site and ad images are AI-created review assets, not official TikTok PDP photos.",
      "Real review excerpts are quoted from the fetched TikTok Shop data and labeled as source-PDP excerpts.",
      "Medical pain claims from individual reviews are not used as product claims."
    ],
    "stats": [
      "4.4 aggregate rating from 2,079 reviews at fetch time",
      "41,195 sold on the product at fetch time",
      "Official Mellow Sleep shop",
      "Shop shows 694.6K sold and 459.6K+ followers at fetch time"
    ]
  },
  "sources": [
    {
      "label": "Parsed TikTok Shop PDP snapshot",
      "url": "docs/source-data/mellow-puff-pillow.json",
      "note": "Local structured extraction from JSON-LD and __MODERN_ROUTER_DATA__; includes product ID, title, brand, variants, prices, reviews, rating, sold count, shop stats, and fetch method."
    },
    {
      "label": "Original TikTok Shop product URL",
      "url": "https://www.tiktok.com/shop/pdp/mens-athletic-t-shirt-by-brand-lightweight-quick-dry-crew-neck-tops/1729494528714773585?source=ecommerce_store&region=US",
      "note": "Fetched with Googlebot user-agent. Despite the slug, this resolves to Mellow Sleep Mellow Puff Pillow."
    },
    {
      "label": "TikTok Shop access instructions",
      "url": "docs/tiktok-shop-access.md",
      "note": "Repo-local instructions documenting the controlled user-agent method needed to fetch full TikTok Shop PDP HTML."
    },
    {
      "label": "Target bedding pillow assortment",
      "url": "https://www.target.com/c/bed-pillows-bedding-home/-/N-5xtv9",
      "note": "Used as a mainstream price-context reference for standard and cooling bed pillows."
    },
    {
      "label": "Walmart cooling pillow assortment",
      "url": "https://www.walmart.com/c/kp/cooling-pillows",
      "note": "Used as marketplace price-context reference for cooling pillows and two-pack value framing."
    }
  ],
  "avatarCandidates": [
    {
      "name": "The Hot, Restless Side Sleeper",
      "marketAwareness": "Problem-aware to solution-aware: they know their current pillow gets warm, goes flat, or feels hard, and they are actively open to cooling and plush pillow solutions.",
      "sophistication": "Level 3: the market has seen memory foam, cooling gel, hotel pillows, and contour pillows, so the hook must be more sensory and specific than 'better sleep.'",
      "corePain": "They keep flipping the pillow, hunting for the cool side, and waking up annoyed because the pillow feels either too hard or too flat.",
      "desiredOutcome": "A plush pillow they can sink into that still feels cool, airy, and comfortable across normal sleep positions.",
      "objections": [
        "Will it arrive damaged or lose stuffing?",
        "Is it too soft to support my head?",
        "Will the cooling side actually feel different?",
        "Can I wash it?",
        "Is the TikTok hype real?"
      ],
      "verdict": "Chosen. It matches the product's strongest source data: cooling ice-silk, cloud-like softness, side/back/stomach positioning, and review language about softness, coolness, and shape retention."
    },
    {
      "name": "The Cozy Bedding Aesthetic Buyer",
      "marketAwareness": "Product-aware: they are drawn to puff-grid textures, pastel colors, and a coordinated bed look.",
      "sophistication": "Level 2: visual novelty and colorways can drive clicks, but the funnel risks becoming decor-first.",
      "corePain": "They want bedding that looks as soft and cozy on camera as it feels in bed.",
      "desiredOutcome": "A bed that feels plush and photographs like a cloud-soft comfort setup.",
      "objections": [
        "Will the color look like the photo?",
        "Will the pillow keep its puffed shape?",
        "Is it just cute or actually comfortable?"
      ],
      "verdict": "Viable for creative angles, but weaker as the main funnel because comfort and cooling reviews carry more purchase intent."
    },
    {
      "name": "The Gift Buyer For Better Sleep",
      "marketAwareness": "Problem-aware: they know someone who complains about bad sleep, hard pillows, or overheating.",
      "sophistication": "Level 2: gifting is emotionally simple but seasonally dependent.",
      "corePain": "They need an easy comfort gift that feels more personal than another throw blanket.",
      "desiredOutcome": "A soft, useful gift with color and size choices.",
      "objections": [
        "Will the recipient like a soft pillow?",
        "Will shipping condition be reliable?",
        "Should I buy one or two?"
      ],
      "verdict": "Useful as a secondary ad angle, not the main funnel. The core buyer likely buys for their own nightly discomfort first."
    }
  ],
  "chosenAvatar": {
    "name": "The Hot, Restless Side Sleeper",
    "persona": "Adults who sleep warm, rotate between side/back/stomach positions, dislike hard pillows, and want a plush, cooling pillow that feels immediately different from their current flat or dense pillow.",
    "marketAwareness": "Problem-aware to solution-aware: they already know their pillow is part of the problem and are looking for comfort/cooling cues that feel credible enough to try.",
    "sophistication": "Level 3: cooling pillow claims are common, so the funnel leads with the product's tactile difference: quilted puff-grid softness plus cooling ice-silk.",
    "corePain": "Nightly pillow frustration: too warm, too hard, too flat, or constantly flipped in search of comfort.",
    "desiredOutcome": "A soft cloud-like pillow that lets their head melt in without feeling hot or dense.",
    "objections": [
      "I need it to arrive intact.",
      "I do not want another pillow that flattens after a week.",
      "I am not sure soft equals supportive enough.",
      "I want real social proof, not just pretty bedding photos."
    ],
    "verdict": "Chosen",
    "whyChosen": "This avatar aligns directly with the PDP language and review patterns: buyers repeatedly mention soft, fluffy, cloud-like, cooling, squishy, and shape-retaining comfort. It also lets the funnel handle the negative reviews honestly with an arrival-condition guarantee."
  },
  "offer": {
    "strategy": "Sell one pillow as the sensory trial, King as the premium upgrade, and a two-pillow reset as the best-value sleep-system offer. Because several real reviews mention ordering another or buying for family, the two-pillow offer fits the observed purchase behavior without inventing a complex bundle.",
    "guarantee": "30-night Cloud-Soft Arrival Guarantee: inspect the pillow on arrival and sleep on it. If it arrives torn or fails to feel plush and cool enough for your routine, request a replacement or refund.",
    "bonus": "Pillow Reset Card: a simple care and fluffing guide for keeping the puff-grid pillow airy after shipping compression and washing.",
    "tiers": [
      {
        "id": "regular-color",
        "label": "Regular Cloud-Soft Pillow",
        "shortLabel": "Regular",
        "price": 3999,
        "unitPrice": "$39.99 each",
        "badge": "Best trial",
        "description": "The main Mellow Puff experience in Baby Blue, Gray, Baby Pink, or Lavender.",
        "items": [
          "1 Regular Mellow Puff Pillow",
          "Cooling ice-silk touch",
          "Pillow Reset Card",
          "30-night Cloud-Soft Arrival Guarantee"
        ],
        "allowedSizes": [
          "Regular"
        ],
        "allowedColors": [
          "baby-blue",
          "gray",
          "baby-pink",
          "lavender"
        ],
        "defaultSize": "Regular",
        "defaultColor": "baby-blue"
      },
      {
        "id": "king",
        "label": "King Pillow Upgrade",
        "shortLabel": "King",
        "price": 4400,
        "unitPrice": "$44.00 each",
        "badge": "Roomier feel",
        "description": "A larger Mellow Puff for bigger beds, broader shoulders, or anyone who wants more pillow.",
        "items": [
          "1 King Mellow Puff Pillow",
          "Available in all source colorways",
          "Cooling ice-silk touch",
          "30-night Cloud-Soft Arrival Guarantee"
        ],
        "allowedSizes": [
          "King"
        ],
        "allowedColors": [
          "white",
          "baby-blue",
          "gray",
          "baby-pink",
          "lavender"
        ],
        "defaultSize": "King",
        "defaultColor": "white"
      },
      {
        "id": "white-regular",
        "label": "White Regular Pillow",
        "shortLabel": "White Regular",
        "price": 5499,
        "unitPrice": "$54.99 each",
        "description": "The white Regular variant exactly as priced in the fetched TikTok Shop JSON-LD.",
        "items": [
          "1 White Regular Mellow Puff Pillow",
          "Classic white bedding look",
          "Pillow Reset Card",
          "30-night Cloud-Soft Arrival Guarantee"
        ],
        "allowedSizes": [
          "Regular"
        ],
        "allowedColors": [
          "white"
        ],
        "defaultSize": "Regular",
        "defaultColor": "white"
      },
      {
        "id": "two-pillow-reset",
        "label": "2-Pillow Bed Reset",
        "shortLabel": "2 Pillow",
        "price": 7800,
        "compareAt": 7998,
        "unitPrice": "$39.00 each",
        "badge": "Best value",
        "description": "A practical pair for couples, guest rooms, or anyone replacing both sides of the bed.",
        "items": [
          "2 Regular Mellow Puff Pillows",
          "Choose one colorway for the pair",
          "Pillow Reset Card",
          "30-night Cloud-Soft Arrival Guarantee"
        ],
        "allowedSizes": [
          "Regular"
        ],
        "allowedColors": [
          "baby-blue",
          "gray",
          "baby-pink",
          "lavender"
        ],
        "defaultSize": "Regular",
        "defaultColor": "gray"
      }
    ]
  },
  "checkout": {
    "title": "Choose your Mellow Puff setup.",
    "subtitle": "This skeleton collects pillow, size, and color choices only. Card entry happens on Stripe-hosted Checkout after keys are configured.",
    "sizeLabel": "Pillow size",
    "colorLabel": "Colorway",
    "defaultTierId": "regular-color",
    "sizeOptions": [
      "Regular",
      "King"
    ],
    "colorOptions": [
      {
        "id": "white",
        "label": "White",
        "swatch": "#f7f4ec"
      },
      {
        "id": "baby-blue",
        "label": "Baby Blue",
        "swatch": "#bcdff4"
      },
      {
        "id": "gray",
        "label": "Gray",
        "swatch": "#a6a9ad"
      },
      {
        "id": "baby-pink",
        "label": "Baby Pink",
        "swatch": "#f7c8d8"
      },
      {
        "id": "lavender",
        "label": "Lavender",
        "swatch": "#c7b4e6"
      }
    ]
  },
  "strategy": {
    "positioning": "A cloud-soft cooling pillow for hot, restless sleepers who want plush comfort without the dense, hard feel of many support pillows.",
    "corePromise": "Sink into the puff-grid softness, then stay with the cool side longer.",
    "throughLine": "Stop flipping your pillow looking for the good side.",
    "landingOpen": "The landing page opens on the nightly frustration of flipping, bunching, and rejecting pillows that feel hot, hard, or flat.",
    "salesClose": "The sales page closes by turning the Mellow Puff into a low-friction sleep reset backed by real review excerpts and an arrival-condition guarantee."
  },
  "assets": {
    "hero": "/assets/generated/site-hero.png",
    "product": "/assets/generated/site-product.png",
    "fabric": "/assets/generated/site-fabric.png",
    "lifestyle": "/assets/generated/site-lifestyle.png",
    "ad1": "/assets/generated/ad-01-product-focus.png",
    "ad2": "/assets/generated/ad-02-hot-sleeper-lifestyle.png",
    "ad3": "/assets/generated/ad-03-benefit-overlay.png",
    "ad4": "/assets/generated/ad-04-ugc-style.png",
    "ad5": "/assets/generated/ad-05-problem-agitation.png"
  },
  "landing": {
    "eyebrow": "Cooling puff-grid comfort for restless sleepers",
    "headline": "Mellow Puff Pillow",
    "subhead": "A quilted, cloud-soft pillow wrapped in cooling ice-silk fabric for side, back, and stomach sleepers who keep searching for the good side of the pillow.",
    "proofPoints": [
      "4.4 rating from 2,079 reviews",
      "41,195 sold at fetch time",
      "Cooling ice-silk fabric",
      "30-night arrival guarantee"
    ],
    "ctas": [
      {
        "label": "Choose my pillow",
        "href": "/checkout"
      },
      {
        "label": "Read the sleep reset",
        "href": "/sales"
      }
    ],
    "sections": [
      {
        "eyebrow": "The nightly problem",
        "title": "Your pillow should not make you negotiate with sleep.",
        "body": "The Mellow Puff funnel opens on a real sleep behavior: flipping, punching, and folding a pillow to find a cooler, softer spot. The product's strongest proof is sensory, so the copy stays close to touch: plush, cool, squishy, and cloud-like.",
        "bullets": [
          "Cooling ice-silk fabric gives the pillow a distinct touch cue.",
          "The quilted puff-grid design gives the product a memorable visual hook.",
          "Side, back, and stomach positioning keeps the offer broad without pretending it is a medical support device."
        ]
      },
      {
        "eyebrow": "Why this product can sell",
        "title": "The reviews already speak in the funnel's language.",
        "body": "Real buyers use phrases like soft as a cloud, super fluffy but not hard, cooling, squishy, and keeps its shape. The funnel amplifies those repeated phrases while being honest about the delivery-condition objection that appears in lower-star reviews.",
        "bullets": [
          "Lead with softness and cooling rather than generic 'better sleep.'",
          "Use review excerpts as proof, clearly labeled as source-PDP excerpts.",
          "Answer damage concerns with an arrival-condition guarantee."
        ]
      },
      {
        "eyebrow": "The offer",
        "title": "Start with one pillow or reset both sides of the bed.",
        "body": "The product has Regular and King variants plus five soft colorways. The funnel keeps the core purchase simple, then gives a two-pillow option because review language shows repeat buying and family gifting behavior.",
        "bullets": [
          "Regular colorways start at $39.99 in the fetched source data.",
          "King variants are $44 in the fetched source data.",
          "The two-pillow reset is a funnel bundle for review, ready to connect to Stripe when keys are added."
        ]
      }
    ]
  },
  "sales": {
    "headline": "The pillow for people who keep flipping to the cool side.",
    "lead": "Mellow Puff is built around a simple promise: a pillow that looks soft, feels soft, and gives hot sleepers a cooler, squishier place to land.",
    "sections": [
      {
        "title": "Soft is not enough. It has to stay inviting at 2 AM.",
        "body": "A lot of pillows feel fine for the first minute and wrong once you actually try to sleep. The Mellow Puff angle is tactile: a quilted puff-grid surface, cooling ice-silk fabric, and a plush feel reviewers compare to a cloud or marshmallow-soft bedding."
      },
      {
        "title": "The proof is specific, not generic.",
        "body": "The source PDP shows a 4.4 aggregate rating from 2,079 reviews and 41,195 sold at fetch time. Positive reviews repeatedly mention softness, cooling, shape retention, and buying another pillow.",
        "bullets": [
          "Soft and squishy without feeling hard.",
          "Cooling side language appears in real reviews.",
          "Repeat purchase behavior supports the two-pillow reset offer."
        ]
      },
      {
        "title": "The objection is visible, so the guarantee should be visible too.",
        "body": "Some lower-star source reviews mention pillows arriving torn or damaged. Instead of hiding that, the funnel turns it into a clear risk reversal: inspect it on arrival, fluff it, sleep on it, and use the guarantee if it does not arrive or perform as promised."
      },
      {
        "title": "Choose based on how much pillow you want.",
        "body": "Regular is the main sensory trial. King is the roomier upgrade. The two-pillow reset makes sense for couples, guest beds, or shoppers who know one soft pillow will make the other side of the bed feel neglected."
      }
    ],
    "reviews": [
      {
        "name": "K**",
        "label": "Real TikTok Shop review excerpt, 2026-06-15",
        "rating": 5,
        "quote": "This pillow is amazing soft as a cloud and cooling at the same time."
      },
      {
        "name": "D**0",
        "label": "Real TikTok Shop review excerpt, 2026-06-11",
        "rating": 5,
        "quote": "Love this pillow! It's super fluffy but not hard. Two different sides. One is silky and soft the other is like memory foam."
      },
      {
        "name": "N**6",
        "label": "Real TikTok Shop review excerpt, 2026-05-20",
        "rating": 5,
        "quote": "This pillow is soft, keeps it shape and one side is cooling. This is truly like sleeping on a marshmallow."
      }
    ],
    "faq": [
      {
        "question": "Is this actually the product from the TikTok URL?",
        "answer": "Yes. The full PDP was fetched with a Googlebot user agent and parsed from JSON-LD plus __MODERN_ROUTER_DATA__. The slug is misleading; the numeric product ID resolves to Mellow Sleep Mellow Puff Pillow."
      },
      {
        "question": "Are the reviews real?",
        "answer": "The review excerpts shown here come from the fetched TikTok Shop structured data. Counts, ratings, and reviews can change over time, so refresh the source snapshot before launch."
      },
      {
        "question": "Is this checkout live?",
        "answer": "No. It is a Stripe-hosted Checkout skeleton. Add Stripe environment variables in Cloudflare Pages to enable test or live checkout."
      },
      {
        "question": "Does this site handle card data?",
        "answer": "No. The architecture redirects customers to Stripe-hosted Checkout so raw card data goes browser to Stripe and never touches this repo or backend."
      }
    ]
  },
  "ads": [
    {
      "id": "ad1",
      "title": "Cloud Soft Product Proof",
      "angle": "Product-focused creative showing the puff-grid texture and soft colorways.",
      "imagePath": "ads/creatives/ad-01-product-focus.png",
      "prompt": "Use case: ads-marketing\nAsset type: static Facebook ad creative\nPrimary request: photorealistic product-focused image of a plush quilted puff-grid bed pillow in white, baby blue, gray, baby pink, and lavender colorways, arranged on a clean bed to show cloud-like softness\nScene/backdrop: bright modern bedroom with crisp white sheets and soft natural morning light\nSubject: soft puffy pillows with quilted square puff-grid texture, no logos, no tags, no text\nStyle/medium: candid but polished bedding product photography\nComposition/framing: square feed composition, pillows fill most of the frame with tactile texture visible\nLighting/mood: airy, clean, cozy, cool-touch comfort\nText (verbatim): none\nConstraints: no logos, no watermarks, no fake labels, no readable text, no medical claims",
      "primaryText": [
        "For the people who keep flipping their pillow to find the cool side: meet the quilted, cloud-soft Mellow Puff.",
        "Soft, squishy, cool-touch comfort in colorways made for a calmer bed."
      ],
      "headlines": [
        "Stop Flipping for the Cool Side",
        "Cloud-Soft Puff-Grid Pillow"
      ]
    },
    {
      "id": "ad2",
      "title": "Hot Sleeper Nightstand",
      "angle": "Lifestyle creative aimed at hot, restless sleepers.",
      "imagePath": "ads/creatives/ad-02-hot-sleeper-lifestyle.png",
      "prompt": "Use case: ads-marketing\nAsset type: static Facebook ad creative\nPrimary request: candid photorealistic image of a cozy bedroom at night with a person resting their head on a plush baby blue quilted puff-grid pillow, looking relieved and comfortable\nScene/backdrop: calm bedroom with nightstand, water glass, soft lamp, cool blue bedding accents\nSubject: everyday adult sleeper partially visible, pillow is the hero, no logos or text\nStyle/medium: native-to-feed lifestyle photo, realistic bedding texture\nComposition/framing: vertical crop, close enough to see pillow texture and relaxed face, no staged stock-photo smile\nLighting/mood: soft night lighting, calm, cool, restful\nText (verbatim): none\nConstraints: no logos, no readable book titles, no watermark, no medical devices, no exaggerated before-after",
      "primaryText": [
        "When your pillow runs hot, sleep turns into a negotiation. Mellow Puff gives you a softer, cooler place to land.",
        "A plush pillow for side, back, and stomach sleepers who want the cool side to last longer."
      ],
      "headlines": [
        "Made for Hot, Restless Sleepers",
        "A Cooler Place to Land"
      ]
    },
    {
      "id": "ad3",
      "title": "Benefit Overlay",
      "angle": "Clear benefit-led creative that names the core behavior.",
      "imagePath": "ads/creatives/ad-03-benefit-overlay.png",
      "prompt": "Use case: ads-marketing\nAsset type: static Facebook ad creative\nPrimary request: square ad image of a hand pressing gently into a white quilted puff-grid pillow, showing plush rebound and cool silky surface, with a clean headline overlay\nScene/backdrop: minimal bed with white and pale blue linens, soft morning light\nSubject: plush pillow surface visibly compressing under a hand, no logos\nStyle/medium: photorealistic tactile product ad photo with tasteful graphic overlay\nComposition/framing: square layout, hand and pillow texture in lower two-thirds, headline in upper third\nLighting/mood: calm, bright, sensory, premium but not luxury\nText (verbatim): \"STOP FLIPPING FOR THE COOL SIDE\"\nConstraints: render the text exactly once, readable bold sans-serif typography, no extra text, no logos, no watermark",
      "primaryText": [
        "The Mellow Puff pitch is simple: cloud-soft puff-grid comfort with a cooling ice-silk touch.",
        "If your current pillow feels hot, hard, or flat, try the soft side of sleep."
      ],
      "headlines": [
        "Stop Flipping the Pillow",
        "Cool-Touch Cloud Comfort"
      ]
    },
    {
      "id": "ad4",
      "title": "UGC Unboxing Bed Reset",
      "angle": "Native-to-feed UGC-style setup showing arrival, fluffing, and bed reset.",
      "imagePath": "ads/creatives/ad-04-ugc-style.png",
      "prompt": "Use case: ads-marketing\nAsset type: static Facebook ad creative\nPrimary request: candid UGC-style phone photo of two plush quilted puff-grid pillows being fluffed on a bed after unboxing, with pastel pillow colors and simple bedding\nScene/backdrop: ordinary bedroom, shipping box edge partly visible, clean but lived-in\nSubject: hands fluffing two soft pillows, puff-grid texture clear, no logos or labels\nStyle/medium: natural phone camera photo, native social feed feel\nComposition/framing: square top-down three-quarter angle, casual arrangement, believable home lighting\nLighting/mood: natural window light, relatable, cozy\nText (verbatim): none\nConstraints: no logos, no readable labels, no watermark, no luxury hotel styling",
      "primaryText": [
        "Unbox, fluff, sink in. The Mellow Puff is made to feel as soft as it looks.",
        "A two-pillow reset for the side of the bed that deserves better than flat and hot."
      ],
      "headlines": [
        "Unbox the Bed Reset",
        "Two Pillows, Softer Nights"
      ]
    },
    {
      "id": "ad5",
      "title": "Problem Agitation",
      "angle": "Shows the frustrating pillow-flipping moment without overclaiming.",
      "imagePath": "ads/creatives/ad-05-problem-agitation.png",
      "prompt": "Use case: ads-marketing\nAsset type: static Facebook ad creative\nPrimary request: realistic bedroom image of a tired person sitting up at night holding a flat old pillow, with a plush quilted Mellow-style puff-grid pillow ready beside them as the inviting alternative\nScene/backdrop: dim bedroom, rumpled sheets, soft lamp, no readable text\nSubject: old flat pillow contrasted with plush puffy pillow, person looks tired but not distressed\nStyle/medium: candid documentary-style photo with subtle ad composition\nComposition/framing: square feed image, old pillow on one side and plush puff-grid pillow on the other, no hard split-screen line\nLighting/mood: relatable nighttime friction turning into comfort\nText (verbatim): none\nConstraints: no logos, no readable signage, no watermark, no medical claims, no shame-based body language",
      "primaryText": [
        "If your pillow is flat, hot, and folded in half by 2 AM, it may be time for a softer reset.",
        "Mellow Puff turns the pillow-flipping habit into a cloud-soft landing."
      ],
      "headlines": [
        "Your Pillow Gave Up",
        "Replace the 2 AM Flip"
      ]
    }
  ]
} satisfies FunnelConfig;
export const generatedAt = "2026-06-16T14:22:03.072Z";
